import Button from "react-bootstrap/Button"
import Dropdown from "react-bootstrap/Dropdown"
import Modal from "react-bootstrap/Modal"
import { useEffect, useState } from "react"

import "./rollback.css"
import { post } from "../../internal/request"
import { API_ADDR } from "../../App"

interface Props {
  hotelReferenceId: string
  show: boolean
  environment: string
  maxRollback: number
  onHide?: (() => void) | undefined
  onDone?: ((err: string) => void) | undefined
}

export default function Rollback(props: Props) {

  const [rollback, setRollback] = useState(1);  // Rollback 1 version by default

  useEffect(() => {
    if (props.show) {
      setRollback(1);
    }
  }, [props.show])

  function rollBack() {
    // Trigger a rollback
    post(`${API_ADDR()}/api/rollback?hotelreferenceid=${props.hotelReferenceId}&environment=${props.environment}&rollback=${rollback}`)
      .then(() => {
        // Call done func
        if (props.onDone)
          props.onDone("")
      })
      .catch((err) => {
        // Call done func with error
        if (props.onDone)
          props.onDone(err)
      })
  }

  const ddOptions = []

  for (var i = 1; i <= props.maxRollback; i++) {
    ddOptions.push(<Dropdown.Item key={i} eventKey={i}>{i}</Dropdown.Item>)
  }


  return <Modal
    show={props.show}
    size="lg"
    centered
    backdrop="static"
    keyboard={false}
  >
    <Modal.Header>
      <Modal.Title>
        <div>Rollback to older version</div>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>Rollback
        <Dropdown as="span" style={{ marginLeft: 5, marginRight: 5 }} onSelect={(eventkey) => setRollback(+(eventkey ?? "2"))}>
          <Dropdown.Toggle variant="secondary" id="rollback-versions">{rollback}</Dropdown.Toggle>
          <Dropdown.Menu>
            {ddOptions}
          </Dropdown.Menu>
        </Dropdown>
        {rollback === 1 ? "version" : "versions"} in the {props.environment} environment cache</div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={props.onHide}>Cancel</Button>
      <Button onClick={() => rollBack()}>Rollback</Button>
    </Modal.Footer>
  </Modal>
}